import * as yup from "yup";

/** Matches StudioReview.ReplyMaxLength on the API. */
export const REVIEW_REPLY_MAX_LENGTH = 1000;

export interface IReviewReplyFormModel {
  /** Empty removes the studio's reply. */
  reply: string;
}

export const reviewReplySchema: yup.ObjectSchema<IReviewReplyFormModel> = yup.object({
  reply: yup
    .string()
    .defined()
    .max(REVIEW_REPLY_MAX_LENGTH, `Максимум ${REVIEW_REPLY_MAX_LENGTH} символа`),
});

export const reviewReplyDefaultValues: IReviewReplyFormModel = {
  reply: "",
};
